import React from 'react';
import { CalendarDays, Users, GraduationCap, ClipboardList } from 'lucide-react';

const ExamStatsCards = ({ examen, sessions, statistiques }) => {
  // S'assurer que sessions est un tableau
  const safeSessions = Array.isArray(sessions) ? sessions : [];
  
  // Calculer le nombre réel de sessions (généralement 3)
  const nombreSessions = 3; // Forcer à 3 comme demandé
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {/* Carte 1: Sessions */}
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200 flex items-center">
        <div className="p-3 rounded-lg bg-blue-100 mr-4">
          <CalendarDays className="h-6 w-6 text-blue-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">Sessions</p>
          <p className="text-2xl font-bold text-gray-900">{nombreSessions}</p>
        </div>
      </div>

      {/* Carte 2: Étudiants */}
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200 flex items-center">
        <div className="p-3 rounded-lg bg-green-100 mr-4">
          <Users className="h-6 w-6 text-green-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">Étudiants</p>
          <p className="text-2xl font-bold text-gray-900">
            {statistiques?.total_etudiants || 0}
          </p>
        </div>
      </div>

      {/* Carte 3: Moyenne */}
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200 flex items-center">
        <div className="p-3 rounded-lg bg-purple-100 mr-4">
          <GraduationCap className="h-6 w-6 text-purple-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">Moyenne</p>
          <p className="text-2xl font-bold text-gray-900">
            {statistiques?.moyenne_generale ? parseFloat(statistiques.moyenne_generale).toFixed(2) : 'N/A'}
          </p>
        </div>
      </div>

      {/* Carte 4: Notes saisies */}
      <div className="bg-white p-5 rounded-xl shadow-sm border border-gray-200 flex items-center">
        <div className="p-3 rounded-lg bg-orange-100 mr-4">
          <ClipboardList className="h-6 w-6 text-orange-600" />
        </div>
        <div>
          <p className="text-sm font-medium text-gray-500">Notes saisies</p>
          <p className="text-2xl font-bold text-gray-900">
            {statistiques?.notes_saisies || 0}/{statistiques?.total_etudiants || 0}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExamStatsCards; 